module.exports = __webpack_public_path__ + "static/media/BELT.c2887e71.svg";